import mongoose, { Schema } from 'mongoose';
import {
  toLower,
} from 'ramda';
import { query as queryModel } from './util';

export const COLLECTION_NAME = 'HelpContent';

const HelpSchema = new Schema({
  component: {
    type: String,
    default: '',
  },
  values: {
    type: JSON,
    default: {},
  },
});

// NOTE: AUM service will ensure indexeds
export const HelpModel = () => mongoose.model(
  toLower(COLLECTION_NAME),
  HelpSchema,
  COLLECTION_NAME,
);

export const query = queryModel(HelpModel);

HelpSchema.statics.findAllHelpContent = () => {
  const Help = HelpModel();
  return Help.find({}).lean();
};

HelpSchema.statics.findHelpContent = (component) => {
  const Help = HelpModel();
  return Help.findOne({ component });
};

export default HelpModel;
